import React, { useContext, useEffect } from 'react';
import { useCmsMegaMenuQuery } from '@/api/cms/cms';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetSettings } from '@/generated/settings';
import { useGetTranslations } from '@/generated/translations';
import styles from './DrawerMegaMenu.module.scss';
import { DrawerMenuLevel } from './DrawerMenuLevel';

interface DrawerMegaMenuProps {
	isMenuOpen?: boolean;
	handleCloseMenu: () => void;
}

export const DrawerMegaMenu: React.FunctionComponent<DrawerMegaMenuProps> = ({ isMenuOpen, handleCloseMenu }) => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);
	const { data: settings } = useGetSettings(segmentationId);
	const { data: cmsMegaMenu } = useCmsMegaMenuQuery(settings?.data, settings?.data.cmsSettings.cmsMegaMenu || '');

	// menuPath tracks the current navigation path as an array of keys
	const [menuPath, setMenuPath] = React.useState<string[]>([]);

	// Reset menuPath when menu closes
	useEffect(() => {
		if (!isMenuOpen) {
			setMenuPath([]);
		}
	}, [isMenuOpen]);

	// Navigate forward
	const handleItemActivation = (key: string) => {
		setMenuPath((arr) => [...arr, key]);
	};

	// Navigate backward
	const handleBack = () => {
		setMenuPath((arr) => arr.slice(0, -1));
	};

	if (!cmsMegaMenu) {
		return null;
	}

	return (
		<nav className={styles.wrapper} role="navigation" aria-label={translations?.data.shared.navigation.primary}>
			<DrawerMenuLevel
				items={cmsMegaMenu}
				level={1}
				menuPath={menuPath}
				isMenuOpen={!!isMenuOpen}
				handleItemActivation={handleItemActivation}
				handleBack={handleBack}
				handleCloseMenu={handleCloseMenu}
			/>
		</nav>
	);
};
